import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

interface AutoFocusPluginProps {
    defaultSelection?: 'rootStart' | 'rootEnd';
}

export const AutoFocusPlugin = ({ defaultSelection = 'rootEnd' }: AutoFocusPluginProps) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        editor.focus(
            () => {
                // If we try and move selection to the same point with setBaseAndExtent, it won't
                // trigger a re-focus on the element. So in the case this occurs, we'll need to correct it.
                // Normally this is fine, Selection API !== Focus API, but fore the editor
                // implementation the bound focus and selection APIs together.
                const activeElement = document.activeElement;
                const rootElement = editor.getRootElement();
                if (
                    rootElement !== null &&
                    (activeElement === null || !rootElement.contains(activeElement))
                ) {
                    rootElement.focus({ preventScroll: true });
                }
            },
            { defaultSelection },
        );
    }, [defaultSelection, editor]);

    return null;
};
